// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"1abecedf","845":"0a3c33e6"}[chunkId] + ".chunk.js";
};